/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface BodyProps {
  idLead: string;
  nomeLead: string;
}

interface Params {
  idLeadCorretor: string;
  body: BodyProps;
}

export function useAlterarNomeLead(props: Params) {
  const registerData = async () => {
    const ALTERAR_NOME_LEAD = `${leadsWebEnviroment}/commom/leads/alterar-nome/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_NOME_LEAD, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_nome_lead"],
    onSuccess: () => {
      toast.success("O nome do Lead foi alterado com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
